import * as Yup from 'yup';

export default Yup.object({
  description: Yup.string()
    .max(255, 'Must be 255 characters or less')
    .required('Please enter a description'),
});
